import { apiClient } from "@/shared/api/client"
import type { CustomBot } from "./types"

export const listBots = async () => (await apiClient.get<CustomBot[]>("/admin/custom-bots")).data

export const listArchivedBots = async () =>
	(await apiClient.get<CustomBot[]>("/admin/custom-bots", { params: { archived: true } })).data

export const listHelperBots = async () =>
	(await apiClient.get<CustomBot[]>("/admin/custom-bots", { params: { helpers: true } })).data

export const getBot = async (id: string) =>
	(await apiClient.get<CustomBot>(`/admin/custom-bots/${id}`)).data

export const createBot = async (body: { token: string; scenarioId?: string }) =>
	(await apiClient.post<CustomBot>("/admin/custom-bots", body)).data

export const updateBot = async (
	id: string,
	body: { name?: string; scenarioId?: string | null; enabled?: boolean; isHelper?: boolean },
) => (await apiClient.patch<CustomBot>(`/admin/custom-bots/${id}`, body)).data

export const replaceBotToken = async (id: string, token: string) =>
	(await apiClient.put<CustomBot>(`/admin/custom-bots/${id}/token`, { token })).data

export const archiveBot = async (id: string) =>
	(await apiClient.post<CustomBot>(`/admin/custom-bots/${id}/archive`)).data

export const restoreBot = async (id: string) =>
	(await apiClient.post<CustomBot>(`/admin/custom-bots/${id}/restore`)).data
